module.exports = __webpack_public_path__ + "static/media/icon.c918b904.svg";